export default (params) => ({
  trigger: {
    name: 'last_order_block.show_element',
    params: params,
  },
  config: {
    schema: {
      order_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'show_last_order',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
